/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_FullInputs */

const en_settings_full = /** @type {(inputs: Settings_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full`)
};

const de_settings_full = /** @type {(inputs: Settings_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständig`)
};

const fr_settings_full = /** @type {(inputs: Settings_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complet`)
};

const es_settings_full = /** @type {(inputs: Settings_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completo`)
};

const it_settings_full = /** @type {(inputs: Settings_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completo`)
};

const nl_settings_full = /** @type {(inputs: Settings_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledig`)
};

const pl_settings_full = /** @type {(inputs: Settings_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełny`)
};

const fi_settings_full = /** @type {(inputs: Settings_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täysi`)
};

const da_settings_full = /** @type {(inputs: Settings_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuld`)
};

const sv_settings_full = /** @type {(inputs: Settings_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständig`)
};

/**
* | output |
* | --- |
* | "Full" |
*
* @param {Settings_FullInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_full = /** @type {((inputs?: Settings_FullInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_FullInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_full(inputs)
	if (locale === "fr") return fr_settings_full(inputs)
	if (locale === "es") return es_settings_full(inputs)
	if (locale === "it") return it_settings_full(inputs)
	if (locale === "nl") return nl_settings_full(inputs)
	if (locale === "pl") return pl_settings_full(inputs)
	if (locale === "fi") return fi_settings_full(inputs)
	if (locale === "da") return da_settings_full(inputs)
	if (locale === "sv") return sv_settings_full(inputs)
	return en_settings_full(inputs)
});